import createSvgIcon from '../Utils/CreateSvgIcon';

export const Plus = createSvgIcon(<path d="M13 13H21V11H13V3H11V11H3V13H11V21H13V13Z" />, 'Plus');
